module.exports = __webpack_public_path__ + "img/expandMoreIcon.0fda2f62.svg";